module.exports = __webpack_public_path__ + "ENG_NarratorVideo_0-bc20951c4a294951d2a6bcd9fe8b14ef.png";